import { render } from "./AppSidebarLink.vue?vue&type=template&id=00d5febc&scoped=true"
import script from "./AppSidebarLink.vue?vue&type=script&lang=js"
export * from "./AppSidebarLink.vue?vue&type=script&lang=js"

import "./AppSidebarLink.vue?vue&type=style&index=0&id=00d5febc&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/FrontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d5febc"]])

export default __exports__